import React, {useEffect, useState} from "react";
import styles from "./JifeiXiaohaoManager.module.css";
import {useDispatch} from "react-redux";
import ExternalApplication from "./ExternalApplication/ExternalApplication";
import InternalApplication from "./InternalApplication/InternalApplication";
const JifeiXiaohaoManager = () => {

    const dispatch = useDispatch();
    const [tabIndex, setTabIndex] = useState("0");

    useEffect(() => {

    }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一

    function tabChange(key) {
        setTabIndex(key)
        console.log(key);
    }
    return (
        <div>
            {tabIndex == "0" ?
                <InternalApplication
                    tabChange = {tabChange}
                    tabIndex = {tabIndex}
                />:
                <ExternalApplication
                    tabChange = {tabChange}
                    tabIndex = {tabIndex}
                />
            }
        </div>
    );
};

export default JifeiXiaohaoManager;
